import SharedProcessingTimeSection from "@/components/feature/SharedProcessingTimeSection";
import type { ProcessingOption } from "@/components/feature/SharedProcessingTimeSection";

const options: ProcessingOption[] = [
  {
    speed: "2–9",
    unit: "Business Days",
    label: "Fast Passport Center",
    tag: "Most Popular",
    tagColor: "bg-[#F6C344] text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission — as a registered courier, we handle it for you",
      "Ideal for MSY international travelers",
      "Perfect for Tulane and Loyola students studying abroad",
      "Great for French Quarter hospitality and tourism professionals",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: true,
  },
  {
    speed: "3–5",
    unit: "Weeks",
    label: "Fast Passport Center",
    tag: "Standard Expedited",
    tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Faster than self-service at New Orleans post offices",
      "Good for planned international trips from MSY",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: false,
    smartSaver: true,
  },
  {
    speed: "1–2",
    unit: "Months",
    label: "Self-Service (Post Office)",
    tag: "Slowest",
    tagColor: "bg-gray-100 text-gray-400",
    features: [
      "No courier access — standard mail only",
      "No document review — errors cause rejection",
      "In-person clerk appointment required at Orleans Parish facilities",
      "Workload shifts with government shutdowns and budget fights",
      "No dedicated agent — you are on your own",
      "Updates only by physical mail letter",
      "No phone or email contact for your case",
      "Cannot upgrade speed after submission",
      "Not suitable if travel is within 10 weeks",
    ],
    highlight: false,
    muted: true,
  },
  {
    speed: "24",
    unit: "Hours*",
    label: "Regional Agency Processing",
    tag: "Emergency Only",
    tagColor: "bg-gray-100 text-gray-500",
    features: [
      "New Orleans has no regional passport agency — closest is Houston",
      "NPIC appointment required — you must secure a slot before traveling",
      "Life-or-death emergencies only with documentation",
      "Bereavement or medical crisis documentation required",
      "Expect to spend an entire day traveling and waiting",
    ],
    highlight: false,
    emergency: true,
  },
];

export default function NewOrleansProcessingTimeSection() {
  return (
    <SharedProcessingTimeSection
      sectionId="processing-options"
      cityName="New Orleans"
      headingExtra="LA"
      introText="New Orleans travelers — cruise passengers departing from the Port of New Orleans, Tulane and Loyola students studying abroad, French Quarter hospitality and tourism professionals, MSY international flyers, and Mardi Gras-connected entertainers traveling overseas — have several options for getting a passport fast. Here is how they compare, and why most Southeast Louisiana residents choose a U.S. Department of State registered passport courier for predictable, professional processing without the need to travel to a regional agency."
      options={options}
      emergencyDescription="New Orleans does not have its own regional passport agency. The closest agency is in Houston. You must obtain an NPIC appointment before traveling, and walk-ins are not accepted at regional passport agencies. For most New Orleans residents, using a registered courier is the practical choice for fast passport processing."
      disclaimerText="*Processing speed depends on eligibility and documentation. New Orleans does not have a regional passport agency — the closest is Houston, roughly 350 miles away. Not all applicants qualify for Regional Agency Processing."
    />
  );
}